<template>
  <div class="copyright_wrap">2016-2017 加优科技有限公司 版权所有 保留一切权利 备案号 1234567u8i</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.copyright_wrap {
  color: #787878;
  font-size: 14px;
  text-align: center;
  position: fixed;
  z-index: 100;
  bottom: 10px;
  right: 0;
  left: 0;
}
</style>